import { render, staticRenderFns } from "./assetSimpleTable.vue?vue&type=template&id=a5bf23b8&scoped=true&"
import script from "./assetSimpleTable.vue?vue&type=script&lang=js&"
export * from "./assetSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./assetSimpleTable.vue?vue&type=style&index=0&id=a5bf23b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bf23b8",
  null
  
)

export default component.exports